module.exports = function anonymous(it
) {
var out='<span rel="localize[file-upload.file-message]">Message:</span><textarea class="js-upload-msg file-message" name="message" rows="3"></textarea>';return out;
}